import { useState, useCallback } from "react";
import axios from "axios";
import { composeApiURL } from "helpers/utility/axiosHelpers";

export interface SeedItem {
  id: string;
  imgUri: string;
}
export interface SeedCluster {
  label: string;
  labelCategoryId: string;
  count: number;
  items: SeedItem[];
}

export interface SampleData {
  id: string;
  image_uri: string;
  label_category_id: string;
}

export interface ClusterData {
  label: string;
  label_category_id: string;
  samples_count: number;
  samples: SampleData[];
}

export interface SeedData {
  seed_sample_clusters: ClusterData[];
}

export const useGetSeed = () => {
  const [seed, setSeed] = useState<SeedCluster[]>();
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>();

  const fetchSeed = useCallback(async (datasetId: string, seedId: string) => {
    try {
      setLoading(true);
      const seedUrl = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/flywheel/${datasetId}/seed/${seedId}`
      );
      const res = await axios.get<SeedData>(seedUrl);
      const seedClusters = res.data.seed_sample_clusters.map(
        (cluster: ClusterData) => ({
          label: cluster.label,
          labelCategoryId: cluster.label_category_id,
          count: cluster.samples_count,
          items: cluster.samples.map((sample: SampleData) => ({
            id: sample.id,
            imgUri: sample.image_uri,
          })),
        })
      );
      setSeed(seedClusters);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { seed, fetchSeed, error, loading };
};
